import api, { apiPrefix } from './Api';
import {
  ShippingMethodsAndBankTransferInstructions,
  shippingMethodsAndBankTransferInstructionsFromResponse,
} from '../interfaces/Shipping/ShippingMethodsAndBankTransferInstructions';

export const getShippingMethods =
  async (): Promise<ShippingMethodsAndBankTransferInstructions> => {
    const response = await api.get(`${apiPrefix}/shippings`);

    return shippingMethodsAndBankTransferInstructionsFromResponse(
      response.data,
    );
  };
